import { getToken } from "./user-service";
import axios from "axios";

/**
 * Search for passengers/bookings by name
 * 
 * @param {Object} params - Search parameters
 * @param {string} params.iata - Airport IATA code (required)
 * @param {string} params.date - Date in YYYY-MM-DD format (required)
 * @param {string} params.searchTerm - Passenger name to search for (required)
 * @returns {Promise<Array>} Array of matching bookings
 */
export const searchPassengers = async (params) => {
    const token = await getToken();

    // Build query string
    const queryParams = new URLSearchParams({
        iata: params.iata,
        date: params.date,
        searchTerm: params.searchTerm,
    });

    const url = `/api/v1/timeline/timeline/passengerSearch?${queryParams.toString()}`;

    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(url, {
                headers: { "Firebase-UID": token },
            });

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Issue searching passengers");
            }

            resolve(response.data);
        } catch (e) {
            console.error("Error searching passengers:", e);
            reject(new Error(e.response?.data?.errors?.[0]?.msg || "Error searching passengers"));
        }
    });
};
